import React, { useState, useEffect } from 'react';
import BaseForm from '../../app/components/BaseForm';
import Input from '../../app/components/Input';
import Select from '../../app/components/Select';
import { FiArrowRight, FiPlus, FiEdit, FiFile, FiMail, FiRefreshCw, FiTrash} from 'react-icons/fi';
import Button from '../../app/components/Button';

const FormEditAutomation = ({ isOpen, onClose, title, selectedAutomation, onSubmit, defaultValues }) => {
  const [formData, setFormData] = useState({
    nome: '',
    descricao: '',
    gatilho: '',
    departamento: '',
    sequencia: '',
    fase: '',
    gatilhoFiltro: '',
    acoes: [],
    camposNovos: [],
    condicoes: [],
  });

  useEffect(() => {
    const initialData = defaultValues || selectedAutomation;
    
    if (initialData) {
      setFormData({
        id: initialData.id || null,
        nome: initialData.nome || '',
        descricao: initialData.descricao || '',
        gatilho: initialData.gatilho || '',
        departamento: initialData.departamento || '',
        sequencia: initialData.sequencia || '',
        fase: initialData.fase || '',
        gatilhoFiltro: initialData.gatilhoFiltro || initialData.filtro || '',
        acoes: Array.isArray(initialData.acoes) ? initialData.acoes : 
              initialData.acao ? [initialData.acao] : [],
        camposNovos: initialData.camposNovos || [],
        condicoes: initialData.condicoes || [],
      });
    } else {
      setFormData({
        nome: '',
        descricao: '',
        gatilho: '',
        departamento: '',
        sequencia: '',
        fase: '',
        gatilhoFiltro: '',
        acoes: [],
        camposNovos: [],
        condicoes: [],
      });
    }
  }, [selectedAutomation, defaultValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleGatilhoSelect = (value) => {
    setFormData(prev => ({
      ...prev,
      gatilho: value,
    }));
  };

  const handleAcaoSelect = (value) => {
    setFormData(prev => ({
      ...prev,
      acoes: [value]
    }));
  };

  const addCampo = () => {
    const novoCampo = {
      id: Date.now(),
      nome: '',
      valor: ''
    };
    
    setFormData(prev => ({
      ...prev,
      camposNovos: [...prev.camposNovos, novoCampo]
    }));
  };

  const removeCampo = (campoId) => {
    setFormData(prev => ({
      ...prev,
      camposNovos: prev.camposNovos.filter(campo => campo.id !== campoId)
    }));
  };

  const addCondicao = () => {
    const novaCondicao = {
      id: Date.now(),
      campo: '',
      operador: 'igual',
      valor: ''
    };
    
    setFormData(prev => ({
      ...prev,
      condicoes: [...prev.condicoes, novaCondicao]
    }));
  };

  const removeCondicao = (condicaoId) => {
    setFormData(prev => ({
      ...prev,
      condicoes: prev.condicoes.filter(condicao => condicao.id !== condicaoId)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const submissionData = {
      ...formData,
      id: formData.id || Date.now(), 
      acao: formData.acoes.length > 0 ? formData.acoes[0] : '',
      filtro: formData.gatilhoFiltro || 'N/A',
      status: 'Ativa',
      sucessos: 0,
      falhas: 0,
      ultimaExecucao: 'N/A'
    };
    
    if (onSubmit && typeof onSubmit === 'function') {
      onSubmit(submissionData);
    }
  };

  const gatilhos = [
    { value: 'card_movido', label: 'Um card foi movido', icon: <FiArrowRight size={24} /> },
    { value: 'novo_card', label: 'Foi criado um novo card', icon: <FiPlus size={24} /> },
    { value: 'card_atualizado', label: 'Um card foi atualizado', icon: <FiEdit size={24} /> },
  ];

  const filtros = [
    { value: '', label: 'Sem Filtro' },
    { value: 'na_fase', label: 'Na Fase' },
    { value: 'para_fase', label: 'Para a Fase' },
    { value: 'de_fase', label: 'De uma Fase' },
  ];

  const departamentos = [
    { value: 'Fiscal', label: 'Fiscal' },
    { value: 'Contábil', label: 'Contábil' },
    { value: 'DP', label: 'DP' },
    { value: 'Financeiro', label: 'Financeiro' },
    { value: 'Sucesso do Cliente', label: 'Sucesso do Cliente' },
    { value: 'Comercial', label: 'Comercial' },
    { value: 'Recursos Humanos', label: 'Recursos Humanos' },
    { value: 'Legalização', label: 'Legalização' },
    { value: 'Gestão de Riscos', label: 'Gestão de Riscos' },
    { value: 'Gestão para Resultados', label: 'Gestão para Resultados' },
    { value: 'Ordens de Serviços', label: 'Ordens de Serviços' },
  ];

  const sequencias = [
    { value: 'Entrada de Cliente', label: 'Entrada de Cliente' },
    { value: 'Base de Colaboradores', label: 'Base de Colaboradores' },
    { value: 'Legalização', label: 'Legalização' },
    { value: 'Banco de Talentos', label: 'Banco de Talentos' },
    { value: 'Obrigações Acessórias', label: 'Obrigações Acessórias' },
    { value: 'Apuração Fiscal', label: 'Apuração Fiscal' },
    { value: 'Programação de Folha', label: 'Programação de Folha' },
    { value: 'Controle de Erros', label: 'Controle de Erros' },
    { value: 'Vendas GR', label: 'Vendas GR' },
    { value: 'Churn', label: 'Churn' },
    { value: 'Rotina financeira', label: 'Rotina financeira' },
  ];

  const fases = [
    { value: 'Admitido', label: 'Admitido' },
    { value: 'Ativos', label: 'Ativos' },
    { value: 'Em Andamento', label: 'Em Andamento' },
    { value: 'Concluído', label: 'Concluído' },
  ];

  const acoes = [
    { value: 'criar_empresa', label: 'Criar Empresa', icon: <FiFile size={24} /> },
    { value: 'enviar_email', label: 'Enviar Email', icon: <FiMail size={24} /> },
    { value: 'atualizar_empresa', label: 'Atualizar Empresa', icon: <FiRefreshCw size={24} /> },
    { value: 'criar_card', label: 'Criar Card', icon: <FiPlus size={24} /> },
    { value: 'mover_card', label: 'Mover Card', icon: <FiArrowRight size={24} /> },
    { value: 'atualizar_card', label: 'Atualizar Card', icon: <FiEdit size={24} /> },
  ];

  const operadores = [
    { value: 'igual', label: 'É igual a' },
    { value: 'diferente', label: 'É diferente de' },
    { value: 'contem', label: 'Contém' },
    { value: 'nao_contem', label: 'Não contém' },
    { value: 'maior', label: 'É maior que' },
    { value: 'menor', label: 'É menor que' },
  ];

  const isValid = formData.nome && formData.gatilho && formData.departamento && formData.sequencia;

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={title || "Editar Automação"}
      submitText="Criar Automação"
      isValid={isValid}
      className='!min-w-[90vw]'
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="col-span-1">
          <h2 className="text-lg font-medium text-[#3f1057] mb-4">Toda Vez que ...</h2>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Nome da Automação</label>
            <Input
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              placeholder="Informe o nome da automação"
              required
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Descrição da Automação</label>
            <div className="relative">
              <textarea
                name="descricao"
                value={formData.descricao}
                onChange={handleChange}
                placeholder="Digite descrição da automação"
                className="peer block w-full appearance-none border border-gray-300 rounded-tl-2xl rounded-tr-2xl rounded-br-2xl p-3 min-h-[100px] focus:outline-none focus:ring-1 focus:ring-purple-500/25 focus:border-purple-700 transition-all"
              />
            </div>
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Gatilho:</label>
            <div className="grid grid-cols-3 gap-3">
              {gatilhos.map(gatilho => (
                <div
                  key={gatilho.value}
                  onClick={() => handleGatilhoSelect(gatilho.value)}
                  className={`
                    flex flex-col items-center justify-center p-4 border rounded-tl-2xl rounded-tr-2xl rounded-br-2xl cursor-pointer transition-all
                    ${formData.gatilho === gatilho.value 
                      ? 'border-[#a04ccb] shadow-[0_0_3px_rgba(124,58,237,0.5)]' 
                      : 'border-gray-300'}
                  `}
                >
                  <div className="flex items-center justify-center w-12 h-12 mb-2">
                    <span className="text-xl text-gray-600">{gatilho.icon}</span>
                  </div>
                  <span className="text-center text-sm">
                    {gatilho.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">No Departamento</label>
            <Select
              name="departamento"
              value={formData.departamento}
              onChange={handleChange}
              options={departamentos.map(dep => ({ value: dep.value, label: dep.label }))}
              placeholder="Selecione um departamento"
              required
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Na Sequência</label>
            <Select
              name="sequencia"
              value={formData.sequencia}
              onChange={handleChange}
              options={sequencias.map(seq => ({ value: seq.value, label: seq.label }))}
              placeholder="Selecione uma sequência"
              required
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Gatilho</label>
            <Select
              name="gatilhoFiltro"
              value={formData.gatilhoFiltro}
              onChange={handleChange}
              options={filtros}
              placeholder="Selecione um filtro para o gatilho"
            />
          </div>
          
          {formData.gatilhoFiltro && (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">Fase</label>
              <Select
                name="fase"
                value={formData.fase}
                onChange={handleChange}
                options={fases}
                placeholder="Selecione a fase"
              />
            </div>
          )}
          
          <div className="mb-4">
            <div className="flex justify-between items-center mb-2">
              <label className="block text-sm font-medium text-gray-700">Condições:</label>
              <Button
                variant="secondary"
                onClick={addCondicao}
              >
                Adicionar Condição
              </Button>
            </div>
            
            {formData.condicoes.length === 0 && (
              <div className="text-center text-gray-500 text-sm mb-2 py-4">
                Nenhuma condição definida.
              </div>
            )}
            
            {formData.condicoes.map((condicao, index) => (
              <div key={condicao.id} className="mb-3 relative">
                <div className="grid grid-cols-3 gap-3">
                  <div className="relative">
                    <label className="block text-xs text-gray-500 mb-1">Campo</label>
                    <div className="relative">
                      <Input
                        placeholder="Nome do campo"
                        value={condicao.campo}
                        onChange={(e) => {
                          const updatedCondicoes = [...formData.condicoes];
                          updatedCondicoes[index].campo = e.target.value;
                          setFormData(prev => ({ ...prev, condicoes: updatedCondicoes }));
                        }}
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">Operador</label>
                    <Select
                      value={condicao.operador}
                      onChange={(e) => {
                        const updatedCondicoes = [...formData.condicoes];
                        updatedCondicoes[index].operador = e.target.value;
                        setFormData(prev => ({ ...prev, condicoes: updatedCondicoes }));
                      }}
                      options={operadores}
                      placeholder="Operador"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">Valor</label>
                    <div className="relative">
                      <Input
                        placeholder="Valor"
                        value={condicao.valor}
                        onChange={(e) => {
                          const updatedCondicoes = [...formData.condicoes];
                          updatedCondicoes[index].valor = e.target.value;
                          setFormData(prev => ({ ...prev, condicoes: updatedCondicoes }));
                        }}
                      />
                    </div>
                  </div>
                </div>

                <button 
                  type="button"
                  onClick={() => removeCondicao(condicao.id)} 
                  className="absolute top-4 right-1 text-red-500 bg-white rounded-full z-10 text-sm"
                >
                  <FiTrash  />
                </button>
              </div>
            ))}
          </div>
        </div>
        
        <div className="col-span-1">
          <h2 className="text-lg font-medium text-[#3f1057] mb-4">Execute a ação ...</h2>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Ações:</label>
            <div className="grid grid-cols-3 gap-3">
              {acoes.map(acao => (
                <div
                  key={acao.value}
                  onClick={() => handleAcaoSelect(acao.value)}
                  className={`
                    flex flex-col items-center justify-center p-4 border rounded-tl-2xl rounded-tr-2xl rounded-br-2xl cursor-pointer transition-all
                    ${formData.acoes.includes(acao.value) 
                      ? 'border-[#a04ccb] shadow-[0_0_3px_rgba(124,58,237,0.5)]' 
                      : 'border-gray-300'}
                  `}
                >
                  <div className="flex items-center justify-center w-12 h-12 mb-2">
                    <span className="text-xl text-gray-600">{acao.icon}</span>
                  </div>
                  <span className="text-center text-sm">
                    {acao.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Na Sequência</label>
            <Select
              name="sequenciaAcao"
              value={formData.sequenciaAcao}
              onChange={handleChange}
              options={sequencias.map(seq => ({ value: seq.value, label: seq.label }))}
              placeholder="Selecione uma sequência"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Na Fase</label>
            <Select
              name="faseAcao"
              value={formData.faseAcao}
              onChange={handleChange}
              options={fases}
              placeholder="Selecione a fase"
            />
          </div>
          
          <div className="mb-4">
            <div className="flex justify-between items-center mb-2">
              <label className="block text-sm font-medium text-gray-700">Campos do novo card:</label>
              <Button
                variant="secondary"
                onClick={addCampo}
              >
                Adicionar Campo
              </Button>
            </div>
            
            {formData.camposNovos.length === 0 && (
              <div className="text-center text-gray-500 text-sm mb-2 py-4">
                Nenhum campo adicional definido.
              </div>
            )}
            
            {formData.camposNovos.map((campo, index) => (
              <div key={campo.id} className="relative mb-3">
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">Campo</label>
                    <div className="relative">
                      <Input 
                        placeholder="Nome do campo"
                        value={campo.nome}
                        onChange={(e) => {
                          const updatedCampos = [...formData.camposNovos];
                          updatedCampos[index].nome = e.target.value;
                          setFormData(prev => ({ ...prev, camposNovos: updatedCampos }));
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">Valor</label>
                    <div className="relative">
                      <Input 
                        placeholder="Valor do campo"
                        value={campo.valor}
                        onChange={(e) => {
                          const updatedCampos = [...formData.camposNovos];
                          updatedCampos[index].valor = e.target.value;
                          setFormData(prev => ({ ...prev, camposNovos: updatedCampos }));
                        }}
                      />
                    </div>
                  </div>
                </div>
                
                <button 
                  type="button"
                  onClick={() => removeCampo(campo.id)} 
                  className="absolute top-4 right-1 text-red-500 bg-white rounded-full z-10 text-sm"
                >
                  <FiTrash />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </BaseForm>
  );
};

export default FormEditAutomation;